import RestfulApiService from '../services/restfulApi';
import GraphQLService from '../services/graphql';
import GeolocationService from '../services/geolocation';
import MapService from '../../services/map';
import {TabsItineraryTransport} from '../enumerator/tabs.enum';
import {CalendarResultType, DatetimeRepresents} from '../enumerator/date.enum';
import {CommercialMode, Feature, TransferType} from '../enumerator/graphql-type.enum';
import {apiAutocomplete, PoisType} from '../enumerator/api-autocomplete.enum';
import {journeysRequest} from '../enumerator/graphql-query.enum';
import {markers} from '../enumerator/mybus-events.enum';
import Translate from '../../services/translate';
import * as moment from 'moment';
import * as mobiscroll from '@mobiscroll/jquery';
import 'regenerator-runtime/runtime';
import ToasterService from './toaster';
import ToastSchema from '../schema/toaster.schema';

mobiscroll.settings = {
    theme: 'mobiscroll',
    lang: 'fr'
};

/**
 * ----------------
 * ItineraryService
 * ----------------
 * gère le système de calcul d'itinéraire
 * */
export default class ItineraryService {
    /** La liste des arrêts en autocomplete */
    static addressList = [];

    /** La position actuelle */
    static currentPosition;

    /** Coordonées d'arrivée */
    static arrivalCoordinates = [];

    /** Coordonées de départ */
    static departureCoordinates = [];

    /** type of time option for search : Departure or Arrival  */
    static calendarTypeOption = DatetimeRepresents.DEPARTURE;

    /** trie les résultats :
     * DEFAULT = le plus rapide,
     * MIN_WALKING=le moins de marche,
     * MIN_TRANSFERTS=le moins de transferts */
    static algorithmType = "DEFAULT";

    /** check if the user have chosen a specific date from the calendar  */
    static withSpecificDate;

    /** store chosen date from calendar */
    static dateFromCalendar;

    /** Filtre par temps */
    static stringTimeFilter;

    /** Les tabs */
    static tabs = TabsItineraryTransport;

    /** number to identifies chosen transport mode  */
    static modeFilter = [];

    /** contient le résultat du calcul d'iti */
    static journeys = {};

    /** contient le nombre de slides */
    static nbSlide = 0;

    /** timeout lors de la saisie pour éviter un trop grand nombre d'appels au geocoder */
    static timeoutSearch;

    static currentSwiper = 0;

    /** contient le module mobiscroll */
    static datetimePicker;

    /**
     * --------------
     * initItinerary
     * --------------
     * Initialise le service de recherche d'itinéraire
     * */
    static initItinerary = function () {
        // init
        if (MapService.map) {
            GeolocationService.getPosition().then(function (position) {
                ItineraryService.currentPosition = position;
            });
        }
        MapService.addControl();
        ItineraryService.initTransportMode();
        ItineraryService.isSearchFromHomePage();
        ItineraryService.initMobiscroll();

        // listeners
        $(document).on('click', '[data-itinerary-transport-item]', ItineraryService.returnCallBackTabs);
        $(document).on('input', '[data-itinerary-input-departure], [data-itinerary-input-arrival]', ItineraryService.inputValueChange);
        $(document).on('click', '[data-itinerary-autocomplete-item]', ItineraryService.selectAutoCompleteItem);
        $(document).on('click', '[data-itinerary-submit]', async function (e) {
            e.preventDefault();
            ItineraryService.getListJourneys();
        });
        $(document).on('change', '[data-schedule]', ItineraryService.changeDateType);
        $(document).on('click', '[data-itinerary-switch]', ItineraryService.switchInputs);
        $(document).on('click', '[data-itinerary-journeys-back]', ItineraryService.backToSearch);

        // datetime picker
        $(document).on('click', '[data-datepicker]', ItineraryService.openDatetime);
        $(document).on('click', '[data-datetime-picker-close]', ItineraryService.closeDatetime);

        // self location
        $(document).on('click', '[data-itinerary-self-location]', ItineraryService.selfLocation);

        // filtres
        $(document).on('click', '[data-itinerary-filtre]', ItineraryService.openModalFilter);
        $(document).on('click', '[data-modal-close-filtre]', ItineraryService.closeModalFilter);
        $(document).on('click', '[data-select-filtre]', ItineraryService.selectFilter);

        if (Theme.page_list.CURRENT_PAGE === Theme.page_list.PAGE_ITINERARY) {
            $(window).resize(ItineraryService.resizeMap);
        }
    }

    /**
     * ---------------
     * openModalFilter
     * ---------------
     * Ouvre la modal des filtres
     */
    static openModalFilter = function () {
        $('[data-modal-filtre]').addClass('active');
    }

    /**
     * ---------------
     * closeModalFilter
     * ---------------
     * ferme la modal des filtres
     */
    static closeModalFilter = function () {
        $('[data-modal-filtre]').removeClass('active');
    }

    /**
     * ---------------
     * selectFilter
     * ---------------
     * permet de sélectionner un filtre
     */
    static selectFilter = function () {
        const filtre = $(this).attr('data-select-filtre');
        ItineraryService.algorithmType = filtre;
        $('[data-select-filtre]').removeClass('active');
        $(this).addClass('active');
    }

    /**
     * ---------------
     * setFilter
     * ---------------
     * permet de set un filtre
     */
    static setFilter = function(filter) {
        $('[data-select-filtre]').removeClass('active');
        $('[data-select-filtre="'+ filter +'"]').addClass('active');
    }

    /**
     * ---------------
     * selfLocation
     * ---------------
     * Set la position de l'utilisateur dans le champ de départ
     */
    static selfLocation = function () {
        let lngLat;
        let input;

        if( $('[data-itinerary-input-departure]').val() === "" ) {
            input = '[data-itinerary-input-departure]';
            if( ItineraryService.currentPosition ) {
                lngLat = ItineraryService.currentPosition.longitude + ',' + ItineraryService.currentPosition.latitude;
                ItineraryService.myPosition(lngLat, input);
            } else {
                GeolocationService.getPosition().then(function(result) {
                    ItineraryService.currentPosition = result;
                    lngLat = result.longitude + ',' + result.latitude;
                    ItineraryService.myPosition(lngLat, input);
                });
            }
        } else {
            input = '[data-itinerary-input-arrival]';
            if( ItineraryService.currentPosition ) {
                lngLat = ItineraryService.currentPosition.longitude + ',' + ItineraryService.currentPosition.latitude;
                ItineraryService.myPosition(lngLat, input);
                ItineraryService.submitForm();
            } else {
                GeolocationService.getPosition().then(function(result) {
                    ItineraryService.currentPosition = result;
                    lngLat = result.longitude + ',' + result.latitude;
                    ItineraryService.myPosition(lngLat, input);
                    ItineraryService.submitForm();
                });
            }
        }
    }

    /**
     * ---------------
     * submitForm
     * ---------------
     * valide la formulaire si les champs sont rempli
     */
    static submitForm = function () {
        if (Theme.page_list.CURRENT_PAGE === Theme.page_list.PAGE_HOME) {
            if ($('[data-itinerary-coords-departure]').attr('value') !== undefined &&
                $('[data-itinerary-coords-arrival]').attr('value') !== undefined &&
                $('[data-itinerary-coords-departure]').attr('value') !== '' &&
                $('[data-itinerary-coords-arrival]').attr('value') !== '') {

                $('[data-home-itinerary]').submit();
                $('[data-itinerary-coords-departure]').attr('value', undefined);
                $('[data-itinerary-coords-arrival]').attr('value', undefined);
            }
        }
    }

    /**
     * -----------------
     * myPosition
     * -----------------
     * set la position de l'utilisateur dans l'input de recherche
     */
    static myPosition = function (position, input) {
        const inputName = input.split('data-itinerary-input-')[1].split(']')[0];
        $( input ).val(Translate.print('itinerary.position'));
        $( input ).attr('data-itinerary-input', position);
        $( input ).attr('value', position);
        $( input ).addClass('focus');
        $( input ).prev('label').addClass('focus');
        $( input ).parent().parent().find('[data-itinerary-coords-' + inputName + ']').attr('value', position);
    }

    /**
     * -------------------
     * inputValueChange
     * -------------------
     * launch autocomplete function on input
     */
    static inputValueChange = function () {
        const value = $(this)[0].value;
        const direction = $(this).attr('data-itinerary-direction');

        clearTimeout(ItineraryService.timeoutSearch);
        ItineraryService.timeoutSearch = setTimeout(async () => {
            if( value !== '' ) {
                RestfulApiService.searchAddress(value)
                    .then((data) => {
                        if (data === undefined) {
                            const content = {
                                title: Translate.print('word.error'),
                                text: data[apiAutocomplete.AUTOCOMPLETE_ERROR.error],
                                status: 'alert'
                            }
                            ToasterService.showToaster(new ToastSchema(content));
                            ItineraryService.clearSuggestionList(direction);
                        } else {
                            ItineraryService.updateList(data, direction);
                            $('[data-itinerary-autocomplete]').trigger('input-fill', '[data-itinerary-input-' + direction + ']');
                        }
                    });
            } else {
                ItineraryService.clearSuggestionList(direction);
                $('[data-itinerary-autocomplete]').trigger('input-empty', '[data-itinerary-input-' + direction + ']');
            }
        }, 500);
    }

    /**
     * -----------
     * clearSuggestionList
     * -----------
     * clear the list of suggestions
     */
    static clearSuggestionList = function (direction = "") {
        ItineraryService.addressList = [];
        let selectedInput;
        (direction === "") ? selectedInput = '[data-itinerary-input]' : selectedInput = '[data-itinerary-input-' + direction + ']';
        $(selectedInput).parent().next('[data-itinerary-autocomplete-list]').children('li').remove();
        $(selectedInput).trigger('input-empty', selectedInput);
    }

    /**
     * -----------
     * updateList
     * -----------
     * update suggestions list from autocomplete service
     */
    static updateList = function (data, direction) {
        ItineraryService.addressList = data.results;
        $('[data-itinerary-autocomplete-list]').children('li').remove();
        $('[data-itinerary-input-' + direction + ']').parent().next('[data-itinerary-autocomplete]').children('[data-itinerary-autocomplete-list]').children('li').remove();

        ItineraryService.addressList.forEach(function (item) {
            // formattage des POI
            if( item.type === 'POI' ) {
                const typePois = Translate.print( PoisType[item.poi.classifications[0].code] );
                if (!!typePois) {
                    item.address.freeformAddress = `${item.poi.name} (${typePois})`;
                }
            }
            $('[data-itinerary-input-' + direction + ']').parent().next('[data-itinerary-autocomplete]').children('[data-itinerary-autocomplete-list]')
                .append(
                    '<li ' +
                        'data-itinerary-autocomplete-item ' +
                        'data-itinerary-autocomplete-coordinates="' + item.position.lon + ',' + item.position.lat + '"' +
                        'data-itinerary-autocomplete-addresse="' + item.address.freeformAddress + '">' +
                    item.address.freeformAddress +
                    '</li>'
                );
        });
    }

    /**
     * ------------
     * selectAutoCompleteItem
     * ------------
     * set value of autocompleteItem into search input
     */
    static selectAutoCompleteItem = function () {
        const value = $(this).attr('data-itinerary-autocomplete-addresse');
        const input = $(this).parent().parent().prev().find('[data-itinerary-input]');
        const coord = $(this).parent().parent().next('[data-itinerary-coords]');

        // set input value
        $(input).val(value);
        // set input coordinates value
        $(input).attr('data-itinerary-input', $(this).attr('data-itinerary-autocomplete-coordinates'));
        // set hidden coordinates value (only homepage)
        $(coord).attr('value', $(this).attr('data-itinerary-autocomplete-coordinates'));

        if( $('[data-itinerary-input-departure]').val() === '' ) {
            $('[data-itinerary-input-departure]').attr('data-itinerary-input', '');
            $('[data-itinerary-input-departure]').attr('value', '');
            $('[data-itinerary-coords-departure]').attr('data-itinerary-input', '');
            $('[data-itinerary-coords-departure]').attr('value', '');
        }
        if( $('[data-itinerary-input-arrival]').val() === '' ) {
            $('[data-itinerary-input-arrival]').attr('data-itinerary-input', '');
            $('[data-itinerary-input-arrival]').attr('value', '');
            $('[data-itinerary-coords-arrival]').attr('data-itinerary-input', '');
            $('[data-itinerary-coords-arrival]').attr('value', '');
        }

        ItineraryService.departureCoordinates = $('[data-itinerary-input-departure]').attr('data-itinerary-input').split(',');
        ItineraryService.arrivalCoordinates = $('[data-itinerary-input-arrival]').attr('data-itinerary-input').split(',');
        ItineraryService.clearSuggestionList();
        ItineraryService.submitForm();
    }


    /**
     * -----------
     * addLoader
     * -----------
     * add itinerary loader
     */
    static addLoader = async function () {
        ItineraryService.removeSliderContent();
        ItineraryService.nbSlide = 0;
        $('.slider-navigation').addClass('invisible');
        if (window.matchMedia("(min-width: 1000px)").matches) {
            $('[data-itinerary-journeys]').addClass('active');
            const noResult =
                '<div class="noResult" data-itinerary-no-result>' +
                '<img src="' + Theme.themeURL + '/assets/dist/images/gif/loading.gif' + '"/>' +
                '<div class="noResult__content">' +
                '<p>' + Translate.print('itinerary.searching') + '</p>' +
                '</div>' +
                '</div>';
            $('[data-itinerary-number-content]').html(noResult);
        } else {
            $('[data-itinerary-submit]').addClass('loading');
        }
    }

    /**
     * -----------
     * addSlideNoResult
     * -----------
     * add no result carding
     */
    static addSlideNoResult = async function () {
        const content = {
            title: Translate.print('toaster.itinerary.title'),
            text: Translate.print('toaster.itinerary.content'),
            status: 'alert',
        }
        ItineraryService.clearTheMap();
        ToasterService.showToaster(new ToastSchema(content));
        ItineraryService.removeSliderContent();
        $('.slider-navigation').addClass('invisible');
        if (window.matchMedia("(min-width: 1000px)").matches) {
            $('[data-itinerary-journeys]').addClass('active');
            const noResult =
                '<div class="noResult" data-itinerary-no-result>' +
                '<img src="' + Theme.themeURL + '/assets/dist/images/gif/bubus-no-result.gif' + '"/>' +
                '<div class="noResult__content">' +
                '<p class="title">' + Translate.print('itinerary.noResult.title') + '</p>' +
                '<p>' + Translate.print('itinerary.noResult.content') + '</p>' +
                '</div>' +
                '</div>';
            $('[data-itinerary-number-content]').html(noResult);
        }
    }

    /**
     * -----------
     * getListJourneys
     * -----------
     * load journeys list
     */
    static getListJourneys = async function () {
        const validDepartureCoordinates = !!(ItineraryService.departureCoordinates && ItineraryService.departureCoordinates.length);
        const validArrivalCoordinates = !!(ItineraryService.arrivalCoordinates && ItineraryService.arrivalCoordinates.length);

        if (validDepartureCoordinates && validArrivalCoordinates) {
            if (JSON.stringify(ItineraryService.arrivalCoordinates) !== JSON.stringify(ItineraryService.departureCoordinates)) {
                ItineraryService.addLoader();
                const date = await ItineraryService.checkCalenderSettings();
                const isForAllModes = ItineraryService.modeFilter.length === 0;
                let modes = [];
                let allowBss = true;

                if (!isForAllModes) {
                    modes = ItineraryService.modeFilter.filter(mode => mode !== Feature.Bss);
                    allowBss = ItineraryService.modeFilter.includes(Feature.Bss);
                }

                const params = {
                    '$from': '[' + ItineraryService.departureCoordinates + ']',
                    '$to': '[' + ItineraryService.arrivalCoordinates + ']',
                    '$date': '"' + date + '"',
                    '$modes': (isForAllModes) ? "[]" : '[' + modes + ']',
                    '$allowBss': (isForAllModes) ? true : allowBss,
                    '$datetimeRepresents': ItineraryService.calendarTypeOption,
                    '$algorithmType': ItineraryService.algorithmType
                }
                const query = GraphQLService.setQueryVar(journeysRequest, params);

                return GraphQLService.getQuery(query)
                    .then((results) => {
                        ItineraryService.journeys = results.data.journeys.journeys;

                        // aucun résultat
                        if (ItineraryService.journeys.length === 0) {
                            if( ItineraryService.algorithmType !== "DEFAULT" ) {
                                ItineraryService.algorithmType = "DEFAULT";
                                ItineraryService.setFilter("DEFAULT");
                                ItineraryService.getListJourneys();
                            }
                        }

                        // supprimer les résultats précédents du slider
                        ItineraryService.removeSliderContent();
                        let i = 0;
                        $.each(ItineraryService.journeys, function (index, item) {
                            ItineraryService.buildSlide(index, item);
                            i++;
                        });

                        if (ItineraryService.nbSlide === 0) {
                            ItineraryService.addSlideNoResult();
                        } else {
                            ItineraryService.drawPoints();
                            ItineraryService.drawTheMap(ItineraryService.journeys[0]);

                            const count = (i > 1) ? Translate.print('itinerary.results.plural') : Translate.print('itinerary.results.single');
                            $('[data-itinerary-number-content]').text(i + count);

                            // affichage
                            $('.slider-navigation').removeClass('invisible');
                            $('[data-itinerary-submit]').removeClass('loading');

                            if (window.matchMedia("(max-width: 1000px)").matches && $('[data-itinerary-slider-item]').length) {
                                $('[data-itinerary-form]').addClass('active');
                                $('#mapItinerary').addClass('active');
                                $('[data-itinerary-journeys]').addClass('active');
                                $('[data-itinerary-journeys-back]').addClass('active');
                                $('[data-itinerary-detail]').removeClass('active');

                                $('html, body').animate({
                                    scrollTop: 0
                                }, 100);

                                setTimeout(() => {
                                    MapService.map.resize();
                                    ItineraryService.swiperIndexChange(ItineraryService.currentSwiper);
                                });
                            } else {
                                ItineraryService.resizeMap();
                            }
                        }
                    })
                    .catch((reason) => {
                        ItineraryService.addSlideNoResult();
                        $('[data-itinerary-submit]').removeClass('loading');
                    });
            } else {
                const content = {
                    title: Translate.print('itinerary.searchError.title'),
                    text: Translate.print('itinerary.searchError.sameAddress'),
                    status: 'alert',
                }
                ToasterService.showToaster(new ToastSchema(content));
            }
        } else {
            const content = {
                title: Translate.print('itinerary.searchError.title'),
                text: Translate.print('itinerary.searchError.invalidAddress'),
                status: 'alert',
            }
            ToasterService.showToaster(new ToastSchema(content));
        }
    }

    /**
     * -----------
     * checkCalenderSettings
     * -----------
     * check if we should use selected date from calendar or current date instead
     */
    static checkCalenderSettings = function () {
        if (ItineraryService.withSpecificDate) {
            return ItineraryService.dateFromCalendar;
        } else {
            return moment();
        }
    }

    /**
     * --------------
     * openDatetime
     * --------------
     * show modal datetime picker
     */
    static openDatetime = function () {
        $('[data-datetime-picker]').addClass('active');
        if (window.matchMedia("(min-width: 650px)").matches) {
            $('[data-itinerary-container]').addClass('hidden');
        } else {
            $('body').addClass('fixed-body');
        }
    }

    /**
     * --------------
     * closeDatetime
     * --------------
     * hide modal datetime picker
     */
    static closeDatetime = function () {
        $('[data-datetime-picker]').removeClass('active');
        if (window.matchMedia("(min-width: 650px)").matches) {
            $('[data-itinerary-container]').removeClass('hidden');
        } else {
            $('body').removeClass('fixed-body');
        }
    }

    /**
     * --------------
     * initMobiscroll
     * --------------
     * initialize mobiscroll datetime picker
     */
    static initMobiscroll = function () {
        const now = moment();
        $('[data-mobiscroll]').mobiscroll().datetime({
            controls: ['calendar'],
            display: 'inline',
            buttons: [
                'now',
                'cancel',
                'set'
            ],
            touchUi: true,
            min: now,
            onSet: function (event) {
                ItineraryService.dateFilter(ItineraryService.calendarTypeOption, moment(event.valueText, 'DD/MM/YYYY hh:mm'));
                ItineraryService.closeDatetime();
            },
            onCancel: function (event, inst) {
                ItineraryService.closeDatetime();
            },
        });
    }

    /**
     * -------------------
     * dateFilter
     * -------------------
     * get informations from calendar and formate date
     */
    static dateFilter = async function (type, date) {
        const now = moment();
        const datetime = moment(date);
        datetime.hour(Number(moment(date).hours()));
        datetime.minute(Number(moment(date).minutes()));
        ItineraryService.dateFromCalendar = datetime.format('YYYY-MM-DDTHH:mm:ssZ');

        if (datetime.diff(moment(), 'minutes') >= 1 || moment().minutes() !== datetime.minutes()) {
            ItineraryService.withSpecificDate = true;
            const typeText = (type === DatetimeRepresents.ARRIVAL) ? CalendarResultType.ARRIVAL_LABEL : CalendarResultType.DEPARTURE_LABEL;
            ItineraryService.stringTimeFilter =
                Translate.print(typeText) +
                ' ' + Translate.print('word.the') + ' ' + moment(date).format('DD/MM') +
                ' ' + Translate.print('word.at') + ' ' + moment(date).format('HH:mm');
        } else {

            ItineraryService.withSpecificDate = false;
            ItineraryService.stringTimeFilter = Translate.print('itinerary.mobiscroll.now');
        }
        $('[data-datetime] p').text(ItineraryService.stringTimeFilter);
    }

    /**
     * ------------
     * changeDateType
     * ------------
     * get value of dateType schedule and modify it into date field
     */
    static changeDateType = function () {
        const attr = $(this).attr('data-schedule-departure');
        if (typeof attr !== typeof undefined && attr !== false) {
            ItineraryService.calendarTypeOption = DatetimeRepresents.DEPARTURE;
        } else {
            ItineraryService.calendarTypeOption = DatetimeRepresents.ARRIVAL;
            ItineraryService.dateFilter(ItineraryService.calendarTypeOption, ItineraryService.dateFromCalendar);
        }
        $('[data-schedule-item]').removeClass('active');
        $('[data-itinerary-schedule]').toggleClass('is-second');

        const date = ItineraryService.checkCalenderSettings();
        ItineraryService.dateFilter(ItineraryService.calendarTypeOption, date);
    }

    /**
     * -------------------
     * initTransportMode
     * -------------------
     * init transport mods
     */
    static initTransportMode = function () {
        ItineraryService.tabs.forEach(function (item, index) {
            const tab = (item.icon !== null) ?
                '<div class="tab__icon ' + item.id + ' "></div>' :
                '<p class="tab__text">' + item.text + '</p>';

            $('[data-itinerary-transport]').append(
                '<div class="tab"' +
                'data-itinerary-transport-item ' +
                'data-itinerary-transport-id="' + item.id + '" ' +
                'data-itinerary-transport-text="' + item.text + '" ' +
                'data-itinerary-transport-index="' + index + '">' +
                tab +
                '</div>'
            );
        });
        $('[data-itinerary-transport-item]').first().addClass('active');
    }

    /**
     * -------------------
     * returnCallBackTabs
     * -------------------
     * Fonction de callback pour actualiser les tabs
     */
    static returnCallBackTabs = function () {
        const id = $(this).attr('data-itinerary-transport-id');
        const indexItem = $(this).attr('data-itinerary-transport-index');

        if (id !== 'ALL') {
            ItineraryService.tabs[0].active = false;
            $('[data-itinerary-transport]').first().removeClass('active');

            const index = ItineraryService.modeFilter.findIndex(mode => mode === id);
            if (index >= 0) {
                ItineraryService.tabs[indexItem].active = false;
                $(this).removeClass('active');
                ItineraryService.modeFilter.splice(index, 1);
                if (!ItineraryService.modeFilter?.length) {
                    ItineraryService.initTabs();
                }
            } else {
                ItineraryService.tabs[indexItem].active = true;
                $(this).addClass('active');
                $('[data-itinerary-transport-item]').first().removeClass('active');
                ItineraryService.modeFilter.push(id);
            }
        } else {
            ItineraryService.initTabs(id);
        }
    }

    /**
     * -------------------
     * initTabs
     * -------------------
     * On réinitialise les tabs
     */
    static initTabs = function (id = 'ALL') {
        ItineraryService.modeFilter = [];
        ItineraryService.tabs = ItineraryService.tabs.map(tab => ({
            ...tab,
            active: tab.id === id
        }));
        $('[data-itinerary-transport-item]').removeClass('active');
        $('[data-itinerary-transport-item]').first().addClass('active');
    }

    /**
     * ------------------
     * switchInputs
     * ------------------
     * Permet d'intervertir les valeurs des inputs
     */
    static switchInputs = function () {
        const departure = $('[data-itinerary-input-departure]').val();
        const arrival = $('[data-itinerary-input-arrival]').val();

        const departureCoords = $('[data-itinerary-input-departure]').attr('data-itinerary-input');
        const arrivalCoords = $('[data-itinerary-input-arrival]').attr('data-itinerary-input');

        $('[data-itinerary-input-departure]').val(arrival);
        $('[data-itinerary-input-arrival]').val(departure);

        $('[data-itinerary-input-departure]').attr('data-itinerary-input', arrivalCoords);
        $('[data-itinerary-input-arrival]').attr('data-itinerary-input', departureCoords);

        if( $( '[data-itinerary-input-departure]' ).val() !== '' ) {
            $( '[data-itinerary-input-departure]' ).addClass('focus' );
            $( '[data-itinerary-input-departure]' ).parent().find('[data-input-label-focus]').addClass('focus');
        }
        if( $( '[data-itinerary-input-arrival]' ).val() !== '' ) {
            $( '[data-itinerary-input-arrival]' ).addClass('focus');
            $( '[data-itinerary-input-arrival]' ).parent().find('[data-input-label-focus]').addClass('focus');
        }
    }

    /**
     * -------------------
     * isSearchFromHomePage
     * -------------------
     * Lance une recherche en arrivant sur la page si la recherche a été effectuée depuis la page d'accueil
     */
    static isSearchFromHomePage = async function () {
        const searchFromHomePage = $('[data-itinerary-search-homepage]').attr('data-itinerary-search-homepage');
        if (searchFromHomePage == true) { // TODO: laisser les deux == et trouver une solution
            ItineraryService.departureCoordinates = $('[data-itinerary-input-departure]').attr('data-itinerary-input').split(',');
            ItineraryService.arrivalCoordinates = $('[data-itinerary-input-arrival]').attr('data-itinerary-input').split(',');
            await ItineraryService.getListJourneys();
        }
    }

    static formatTime = function (time) {
        if (time > 60) {
            const hours = parseInt(time / 60);
            let minutes = time % 60;
            if (minutes < 10) {
                minutes = '0' + minutes;
            }
            return time = hours + 'h' + minutes;
        } else {
            return time + 'min';
        }
    }

    /**
     * -----------------
     * buildSlide
     * -----------------
     * construit une slide à partir des données
     * affichage la slide dans le slider
     * */
    static buildSlide = function (index, journey) {
        const today = moment();
        const arrival = moment(journey.arrivalDateTime);
        const departure = moment(journey.departureDateTime);
        const departureTime = departure.format('HH[h]mm');
        const departureDate = departure.format('DD[/]MM');
        let timeToDestination = moment(arrival).diff(moment(), 'minutes');
        if (timeToDestination <= 0) {
            return false;
        }
        let timeTravel = moment(arrival).diff(moment(departure), 'minutes');
        timeToDestination = ItineraryService.formatTime(timeToDestination);
        timeTravel = ItineraryService.formatTime(timeTravel);
        let onlyWalk = false;
        let travelDetails = '';

        $.each(journey.sections, function (i, item) {
            switch (item.transferType) {
                case TransferType.PublicTransport:
                    const style = "background:#" + item.color + ";color:#" + item.textColor;
                    const terImg = Theme.themeURL + "/assets/dist/images/type/TER.svg";

                    if (item.code !== '') {
                        // bus, tramway, metro
                        travelDetails +=
                            '<div class="line" style="' + style + '">' +
                            item.code +
                            '</div>';
                    } else {
                        // ter
                        travelDetails +=
                            '<div class="ter">' +
                            '<img src="' + terImg + '"/>' +
                            '</div>';
                    }
                    break;

                case TransferType.StreetNetwork:
                    if (i > 0 && journey.sections[i - 1].transferType === TransferType.BssRent) {
                        travelDetails +=
                            '<div class="walk">' +
                            '<img src="' + Theme.themeURL + "/assets/dist/images/type/VELO.svg" + '"/>' +
                            '</div>';
                    } else {
                        const walkImg = Theme.themeURL + "/assets/dist/images/type/WALK.svg";
                        travelDetails +=
                            '<div class="walk">' +
                            '<img src="' + walkImg + '"/>' +
                            '</div>';
                    }

                    break;

                case TransferType.BssPutBack:
                    break;
            }

            // ajoute le marker "suivant"
            if (item.transferType === TransferType.PublicTransport ||
                item.transferType === TransferType.StreetNetwork) {
                if ((journey.sections.length - 1) !== i) {
                    const terminusImg = Theme.themeURL + "/assets/dist/images/type/TERMINUS.svg";
                    travelDetails +=
                        '<div class="next">' +
                        '<img src="' + terminusImg + '"/>' +
                        '</div>';
                }
            }
        });

        if (journey.sections?.length === 1 && journey.sections[0]?.transferType === TransferType.StreetNetwork) {
            onlyWalk = true;
            travelDetails +=
                '<p class="only-walk">' +
                'Trajet uniquement à pied' +
                '</p>';
        }

        let destination = '';
        let begin = '';
        if (today.isSame(departure, 'd')) {
            destination =
                '<div class="item-content-destination">' +
                '<span>' + Translate.print('itinerary.results.arrivalAt') + '</span>' +
                '<p data-itinerary-departureDateTime>' + timeToDestination + '</p>' +
                '</div>';
            begin =
                '<span>' + Translate.print('itinerary.results.departureAt') +
                '<strong data-itinerary-arrivalDateTime>' + departureTime + '</strong>' +
                '</span>';
        } else {
            destination =
                '<div class="item-content-destination">' +
                '<span>' + Translate.print('itinerary.results.travelTime') + '</span>' +
                '<p data-itinerary-departureDateTime>' + timeTravel + '</p>' +
                '</div>';
            begin =
                '<span>' + Translate.print('itinerary.results.departureAt') +
                '<strong data-itinerary-arrivalDateTime>' + departureTime + '</strong>' +
                ' le ' + departureDate +
                '</span>';
        }

        const className = onlyWalk ? 'walk' : '';
        let dataAttr = "";
        if( index === 0 ) {
            switch(ItineraryService.algorithmType) {
                case "DEFAULT":
                    dataAttr = Translate.print('itinerary.filter.DEFAULT');
                    break;
                case "MIN_WALKING":
                    dataAttr = Translate.print('itinerary.filter.MIN_WALKING');
                    break;
                case "MIN_TRANSFERS":
                    dataAttr = Translate.print('itinerary.filter.MIN_TRANSFERS');
                    break;
            }
        }

        const slide =
            '<div class="item ' + className + '" data-item="' + dataAttr + '" data-itinerary-slider-item="' + index + '">' +
            '<div class="item-content">' +
            destination +
            '<div class="item-content-journey">' +
            begin +
            '<div class="sections">' +
            travelDetails +
            '</div>' +
            '</div>' +
            '</div>' +
            '<div class="item-footer">' +
            '<a data-itinerary-showDetails="' + index + '">' + Translate.print('itinerary.results.moreDetails') + '</a>' +
            '</div>' +
            '</div>';

        $('[data-itinerary-slider]').slick('slickAdd', slide);
        ItineraryService.nbSlide++;
    }

    /**
     * ------------------
     * removeSliderContent
     * ------------------
     * supprime le contenu du slider
     * */
    static removeSliderContent = function () {
        $('[data-itinerary-slider-item]').remove();
    }

    /**
     * --------------
     * removeDetail
     * --------------
     * supprime le contenu du détail d'un trajet
     * */
    static removeDetail = function () {
        $('[data-itinerary-detail-content]').empty();
    }

    /**
     * --------------
     * buildDetail
     * --------------
     * construction et affichage du détail d'un trajet
     * */
    static buildDetail = function (journey) {

        // remove old detail
        ItineraryService.removeDetail();

        // dates
        const arrival = moment(journey.arrivalDateTime);
        const departure = moment(journey.departureDateTime);
        const arrivalTime = arrival.format('HH[h]mm');
        const departureTime = departure.format('HH[h]mm');
        const sectionCount = journey.sections.length;

        // set travel resume infos
        $('[data-itinerary-detail-departure]').text(departureTime);
        $('[data-itinerary-detail-arrival]').text(arrivalTime);
        $('[data-itinerary-detail-from]').text(journey.from.label);
        $('[data-itinerary-detail-to]').text(journey.to.label);

        // build sections
        const sectionsManaged = ItineraryService.changeDateFormat(journey);
        $.each(sectionsManaged, function (index, item) {
            if (item.isVisible) {
                // only publicTransport (bus, tram, metro, ter) or StreetNetwork (walk)
                if (item.transferType === TransferType.PublicTransport || item.transferType === TransferType.StreetNetwork) {
                    const stopList = (item.stopDateTimes !== undefined) ? ItineraryService.buildDetailStopList(item) : '';
                    const step = ItineraryService.buildDetailSteps(item, stopList, index, sectionsManaged);
                    $('[data-itinerary-detail-content]').append(step);
                }

                if (index + 1 === sectionCount) {
                    const lastStep =
                        '<div class="step" data-itinerary-detail-step="' + sectionCount + '">' +
                        '<div class="hour">' + item.arrivalDateTimeFormated + '</div>' +
                        '<div class="timeline">' +
                        '<div class="pointer" style="background:#000000"></div>' +
                        '</div>' +
                        '<div class="details">' +
                        '<p class="detailsAddress">' + item.to.name + '</p>' +
                        '</div>' +
                        '</div>';
                    $('[data-itinerary-detail-content]').append(lastStep);
                }
            }
        });
    }

    /**
     * -----------------
     * changeDateFormat
     * -----------------
     * Adapte le datetime des étapes
     */
    static changeDateFormat = function (journey) {
        return journey.sections.map((section, index) => {
            if (moment(section.arrivalDateTime, ['YYYY-MM-DDTHH:mm:ssZ']).isValid()) {
                section.isVisible = true;
                section.arrivalDateTimeFormated = moment(section.arrivalDateTime, ['YYYY-MM-DDTHH:mm:ssZ']).format('HH:mm');
                section.departureDateTimeFormated = moment(section.departureDateTime, ['YYYY-MM-DDTHH:mm:ssZ']).format('HH:mm');
                section.durationFormated = Math.round(section.duration / 60) > 0 ? Math.round(section.duration / 60) : 1;

                // à pieds ou en transfert
                if ((section.transferType === TransferType.StreetNetwork || section.transferType === TransferType.Transfer) &&
                    journey.sections[index + 1]?.transferType === TransferType.Waiting) {
                    section.durationFormated += Math.round(journey.sections[index + 1].duration / 60);
                    if (section.transferType === TransferType.Transfer && section.geojson?.properties[0]?.length === 0) {
                        section.isVisible = false;
                    } else{
                        journey.sections[index + 1].isVisible = false;
                    }
                }

                // à pieds + waiting + n'est pas la première section
                else if (index > 0 && section.transferType === TransferType.StreetNetwork && journey.sections[index - 1].transferType === TransferType.Waiting) {
                    section.durationFormated += Math.round(journey.sections[index - 1].duration / 60);
                    section.from = journey.sections[index - 1].from;
                    section.departureDateTimeFormated = moment(journey.sections[index - 1]?.departureDateTime,['YYYY-MM-DDTHH:mm:ssZ']).format('HH:mm');
                    journey.sections[index - 1].isVisible = false;
                }

                // vélo + étape avant à pieds + n'est pas la première section
                else if (index > 0 && section.transferType === TransferType.BssRent && journey.sections[index - 1].transferType === TransferType.StreetNetwork) {
                    journey.sections[index - 1].duration += section.duration;
                }
            }
            return section;
        })
    }

    /**
     * ---------------
     * formatDuration
     * ---------------
     * formate un temps en secondes en minutes / heures
     */
    static formatDuration = function (duration) {
        if( duration > 60 ) {
            duration = Math.floor(duration / 60) + 'h' + duration % 60;
        } else {
            duration = duration + 'min';
        }
        return duration;
    }

    /**
     * -----------------
     * buildDetailSteps
     * -----------------
     * Retourne le détail d'une étape au format HTML
     */
    static buildDetailSteps = function (item, stopList, index, sections) {

        let stepType = '';

        switch (item.transferType) {
            case TransferType.PublicTransport:
                let style = style = "background:#" + item.color + ";color:#" + item.textColor;
                if( item.color === "FFFFFF" ) {
                    style += ";border-color:#" + item.textColor;
                }
                const terminusImg = Theme.themeURL + '/assets/dist/images/type/TERMINUS.svg';
                const terImg = Theme.themeURL + '/assets/dist/images/type/TER.svg';

                let type = '';
                if (item.code !== '') {
                    type =
                        '<div class="direction">' +
                        '<div class="bubble" style="' + style + '">' + item.code + '</div>' +
                        '<img class="next" src="' + terminusImg + '" alt=""/>' +
                        '<p>' + item.to.name + '</p>' +
                        '</div>';
                } else {
                    type =
                        '<div class="direction">' +
                        '<div class="ter"><img src="' + terImg + '" alt=""></div>' +
                        '<img class="next" src="' + terminusImg + '" alt=""/>' +
                        '<p>' + item.to.name + '</p>' +
                        '</div>';
                }

                stepType +=
                    '<div class="timeline">' +
                    '<div class="pointer withColor" style="' + style + '"></div>' +
                    '<div class="line withColor" style="' + style + '"></div>' +
                    '</div>' +
                    '<div class="details">' +
                    '<p class="detailsAddress">' + item.from.name + '</p>' +
                    '<div class="detailsMore">' +
                    type +
                    stopList +
                    '</div>' +
                    '</div>';
                break;
            case TransferType.StreetNetwork:
                let stepIcon = Theme.themeURL + '/assets/dist/images/type/WALK.svg';
                let stepPointName = item.from.name;
                const iconImg = Theme.themeURL + '/assets/dist/images/markers/userposition.svg';
                const firstStepIcon = (index === 0) ? '<img src="' + iconImg + '" alt="">' : '';
                const distance = (item.geojson !== null) ? item.geojson.properties[0].length + 'm' : '';

                if (index > 0 && sections[index - 1].transferType === TransferType.BssRent) {
                    stepIcon = Theme.themeURL + '/assets/dist/images/type/VELO.svg';
                }

                if (index > 0 && item.from.name === '') {
                    if (sections[index - 1].transferType === TransferType.BssRent) {
                        stepPointName = item.to.name;
                    } else {
                        stepPointName = sections[index - 1].from.name;
                    }
                }

                stepType +=
                    '<div class="timeline">' +
                        '<div class="pointer">' +
                            firstStepIcon +
                        '</div>' +
                        '<div class="line"></div>' +
                    '</div>' +
                    '<div class="details">' +
                        '<p class="detailsAddress">' + stepPointName + '</p>' +
                        '<div class="detailsMore">' +
                            '<p class="distance">' +
                                '<img class="icon" src="' + stepIcon + '" />' +
                                '<span class="number">' + distance + '</span>' +
                            '</p>' +
                        '</div>' +
                    '</div>';
                break;
        }

        const dateToDisplay = index === sections.length - 1 ? item.departureDateTimeFormated : item.departureDateTimeFormated;
        item.durationFormated = ItineraryService.formatDuration(item.durationFormated);

        return '<div class="step" data-itinerary-detail-step="' + index + '">' +
            '<div class="hour">' + dateToDisplay + '</div>' +
            '<div class="time">' + item.durationFormated + '</div>' +
            stepType +
            '</div>';
    }

    /**
     * -----------------
     * buildDetailStopList
     * -----------------
     * Retourne la liste des arrêts au format HTML
     */
    static buildDetailStopList = function (item) {
        const stopCount = item.stopDateTimes.length;
        let transportImg = '';
        let list = '';
        const mode = CommercialMode;

        switch (item.commercialMode) {
            case 'Bus':
                transportImg = CommercialMode.Bus;
                break;
            case 'Metro':
                transportImg = CommercialMode.Metro;
                break;
            case 'Tramway':
                transportImg = CommercialMode.Tramway;
                break;
            case 'Train':
                transportImg = CommercialMode.Train;
                break;
            case 'Ter':
                transportImg = CommercialMode.Train;
                break;
            case 'TER':
                transportImg = CommercialMode.Train;
                break;
            case 'Intercités':
                transportImg = CommercialMode.Train;
                break;
            case 'Car TER':
                transportImg = CommercialMode.Train;
                break;
            case 'TGV INOUI':
                transportImg = CommercialMode.TGV_INOUI;
                break;
            case 'OUIGO':
        }

        $.each(item.stopDateTimes, function (index, stop) {
            list += '<li>' + stop.stopPoint.name + '</li>';
        });

        const stopList =
            '<div class="stops" data-itinerary-detail-stops>' +
            '<p>' +
            '<img class="icon" src="' + transportImg + '" alt="' + item.commercialMode + '"/>' +
            '<span class="number">' + stopCount + ' arrêts</span>' +
            '<span class="chevron"></span>' +
            '</p>' +
            '<ul>' +
            list +
            '</ul>' +
            '</div>';
        return stopList;
    }

    /**
     * -------------
     * openDetail
     * -------------
     * ouvre le détail d'un trajet
     * */
    static openDetail = function () {
        const id = $(this).attr('data-itinerary-showDetails');
        ItineraryService.buildDetail(ItineraryService.journeys[id]);
        $('[data-itinerary-detail]').addClass('active').attr('data-id-selected', id);
        $('[data-itinerary-journeys]').removeClass('active');

        $('[data-datetime-picker]').removeClass('active');
        $('[data-itinerary-container]').addClass('hidden');

        ItineraryService.centerMapBounds(ItineraryService.journeys[id], {
            top: 40,
            bottom: 400,
            left: 100,
            right: 100
        });
    }

    /**
     * -------------
     * closeDetail
     * -------------
     * ferme le détail d'un trajet
     * */
    static closeDetail = function () {
        const $detail = $('[data-itinerary-detail]');
        $detail.removeClass('active');
        $('[data-itinerary-journeys]').addClass('active');
        $('[data-itinerary-container]').removeClass('hidden');
        const id = $detail.attr('data-id-selected');
        ItineraryService.centerMapBounds(ItineraryService.journeys[id], {
            top: 220,
            bottom: 350,
            left: 100,
            right: 100
        });
    }

    /**
     * -------------
     * toggleShowStopsDetail
     * -------------
     * déroule la liste des arrêts d'une étape
     * */
    static toggleShowStopsDetail = function () {
        $(this).toggleClass('active');
    }

    /**
     * ---------------
     * setUserLocation
     * ---------------
     * ajoute le marker user-position sur la map
     * */
    static setUserLocation = function () {
        const coord = [ItineraryService.currentPosition.longitude, ItineraryService.currentPosition.latitude];
        MapService.addImageMarker(coord, markers.USERPOSITION, markers.USERPOSITION.NAME);
    }

    /**
     * -------------------
     * drawPoints
     * -------------------
     * Affiche les points départ / arrivé
     */
    static drawPoints = function () {
        // departure
        if (MapService.layerExist('departure')) {
            MapService.removePoint('departure');
        }
        if (MapService.layerExist('arrival')) {
            MapService.removePoint('arrival');
        }

        MapService.addPoint(ItineraryService.departureCoordinates, 'departure', '#FFFFFF', '#000000');
        MapService.addPoint(ItineraryService.arrivalCoordinates, 'arrival', '#000000', '#FFFFFF');

        // gesture
        ItineraryService.swiperIndexChange(0);

        setTimeout(() => {
            MapService.moveToTopLayer('arrival');
            MapService.moveToTopLayer('departure');
        }, 50);
    }

    /**
     * -----------
     * clearTheMap
     * -----------
     * Clear layers and popups of the map
     */
    static clearTheMap = function (excludeLayers = []) {
        MapService.resetAllLayers(excludeLayers);
    }

    /**
     * -----------
     * drawTheMap
     * -----------
     * draw the journey lines on the map
     */
    static drawTheMap = async function (journey) {
        ItineraryService.clearTheMap(['departure', 'arrival']);
        const arrayPromises = [];
        await journey.sections.forEach((section, index) => {
            let color = '#000000';
            if (section.color) {
                arrayPromises.push(MapService.addShape(section.geojson, `#${section.color}`, section.id));
                color = `#${section.color}`;
            } else if (index > 0 && journey.sections[index - 1].transferType === TransferType.BssRent) {
                arrayPromises.push(MapService.addShape(section.geojson, '#35C9AB', section.id));
                color = '#35C9AB';
            } else {
                arrayPromises.push(MapService.addShape(section.geojson, '#000000', section.id, section.transferType === 'STREET_NETWORK'));
            }

            if (section.geojson?.coordinates?.length) {
                arrayPromises.push(MapService.addPoint(
                    section.geojson.coordinates[0],
                    `section_${index}`,
                    color,
                    '#FFFFFF',
                    6,
                    2
                ));
            }
        });

        Promise.all(arrayPromises).then(async () => {
            await journey.sections.forEach((section, index) => {
                if (MapService.layerExist(`section_${index}`)) {
                    MapService.moveToTopLayer(`section_${index}`);
                }
            });

            if (MapService.layerExist(`arrival`) && MapService.layerExist(`departure`)) {
                MapService.moveToTopLayer('arrival');
                MapService.moveToTopLayer('departure');
            }
        });
    }

    /**
     * -----------
     * swiperIndexChange
     * -----------
     * detect swipe action
     */
    static swiperIndexChange = function (index) {
        ItineraryService.currentSwiper = index;
        if (MapService.map) {
            ItineraryService.drawTheMap(ItineraryService.journeys[index]);
            ItineraryService.centerMapBounds(ItineraryService.journeys[index], {
                top: 220,
                bottom: 350,
                left: 100,
                right: 100
            });
        }
    }

    /**
     * -----------
     * centerMapBounds
     * -----------
     * Centre la map sur un departure
     */
    static centerMapBounds = function (departures, padding) {
        MapService.map.fitBounds([
            departures.from?.coord?.coordinates,
            departures.to?.coord.coordinates,
        ], {
            padding
        });
    }

    /**
     * -----------
     * backToSearch
     * -----------
     * permet de revenir à la recherche sur mobile
     */
    static backToSearch = function () {
        $('[data-itinerary-form]').removeClass('active');
        $('#mapItinerary').removeClass('active');
        $('[data-itinerary-journeys]').removeClass('active');
    }

    /**
     * -------------
     * resizeMap
     * -------------
     * gère l'affichage recherche/résultats sur la page calcul d'itinéraire
     */
    static resizeMap = function () {
        if (window.matchMedia("(min-width: 1001px)").matches && ItineraryService.nbSlide > 0) {
            ItineraryService.swiperIndexChange(ItineraryService.currentSwiper);
            $('[data-itinerary-form]').removeClass('active');
            $('#mapItinerary').removeClass('active');
            $('[data-itinerary-journeys-back]').removeClass('active');
        }
    }
}